import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { CommentableEntityType, CommentsNotificationType } from "./interface";

export interface NotificationViewDto {
  notificationId: number;
  entityId: string;
  entityType: CommentableEntityType;
  notificationDateTimeStamp: string;
  notificationType: CommentsNotificationType;
  notificationAuthorId: number;
  notificationContent: string;
  notificationViewed: boolean;
  commentId?: string;
  entityTag: string;
}
export type INotificationReturn = IAxiosReturn<NotificationViewDto[]>;

/**
 * Gets user notifications from the back end
 *
 * @param backEndUrl - The backend API base URL for making HTTP requests
 * @param _ - Unused parameter for consistency with loader signature
 * @param controller - Optional AbortController for cancelling the request
 * @returns Promise<INotificationReturn>
 */
export const getUserNotifications = async (
  backEndUrl: string,
  _: string,
  controller?: AbortController,
): Promise<INotificationReturn> => {
  // Get data
  try {
    const response = await axios.get(
      `${backEndUrl}Comments/GetUserNotifications`,
      controller !== undefined ? { signal: controller.signal } : undefined,
    );
    // Return successful result
    return {
      success: true,
      data: response.data,
    };
  } catch (error: unknown) {
    return processAxiosError("Load Notifications failed", error);
  }
};
